<script setup lang="ts">
import type Konva from "konva";
import { twMerge } from "tailwind-merge";

import { ShapeTextSizeOptions } from "~/telestrations/constants/colors";
import { TELESTRATION_TOOLTIP_CONTAINER } from "~/telestrations/constants/tooltip";

const { t } = useI18n();
const shapesStore = useShapesStore();
const isMenuOpened = ref(false);

const options = computed(() => {
  if (shapesStore.selectedShape) {
    return ShapeTextSizeOptions[shapesStore.selectedShape.type].map((option) => ({
      ...option,
      label: t(option.labelKey),
    }));
  }

  return [];
});
const selectedTextSize = computed(() => {
  if (shapesStore.selectedShape) {
    const currentFontSize = (shapesStore.selectedShape as unknown as Konva.Text).fontSize;

    if (typeof currentFontSize === "number") {
      return currentFontSize;
    }

    return null;
  }

  return options.value[0]?.value;
});

const inputClasses = computed(() =>
  twMerge(
    "!border-none !gap-x-2 px-1.5",
    isMenuOpened.value ? "!bg-neutral-light-100 dark:!bg-neutral-dark-500" : "hover:!bg-neutral-light-100 dark:hover:!bg-neutral-dark-500"
  )
);

function onShow() {
  isMenuOpened.value = true;
}

function onHide() {
  isMenuOpened.value = false;
}

function onChange(value: number[]) {
  if (!shapesStore.selectedShape) {
    return;
  }

  shapesStore.updateShape(shapesStore.selectedShape, { fontSize: value });
}
</script>

<template>
  <template v-if="options.length">
    <USelectMenu
      :model-value="selectedTextSize"
      :options="options"
      :input-class="inputClasses"
      list-class="flex p-2 gap-2"
      item-class="rounded aria-selected:text-blue-500 !px-2 aria-selected:bg-neutral-light-100 dark:aria-selected:bg-neutral-dark-500 hover:bg-neutral-light-100 dark:hover:bg-neutral-dark-500 dark:aria-selected:text-blue-500"
      variant="inline"
      size="sm"
      list-item-size="auto"
      :divider="false"
      :hide-trailing-icon="true"
      :render-in-portal="false"
      @show="onShow"
      @hide="onHide"
      @update:model-value="onChange"
    >
      <UIcon
        v-tooltip="{
          content: t('labels.change_text_size'),
          container: TELESTRATION_TOOLTIP_CONTAINER,
        }"
        class="size-6"
        name="text-size"
      />
    </USelectMenu>
  </template>
</template>
